export var MIN_PRICE = 'MIN_PRICE';
export var MAX_PRICE = 'MAX_PRICE';
export var MIN_LENGTH = 'MIN_LENGTH';
export var MAX_LENGTH = 'MAX_LENGTH';
export var RESET_RANGE = 'RESET_RANGE';
